export const sidebarDisplayMeta = {
  SystemReservationAction: {
    fields: ['reservation_uid', 'reserved_for', 'date', 'items'],
  },
  ReservationAction: {
    fields: ['entity_display_name', 'display_name', 'date'],
  },
  DefaultAction: {
    fields: ['entity_display_name', 'display_name', 'date'],
  },
  GroupDateField: {
    fields: ['display_name', 'field_name', 'date'],
  },
}
